module.exports = __webpack_public_path__ + "img/L_2C.b25fd213.png";